import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '../components/Dialog';
import { supabase } from '../sync/useSync';
import { cn } from '../lib/cn';
import { refreshWorkspacesSoon, useWorkspaceUi } from './state';

const field = 'w-full rounded-lg border border-border bg-bg px-2 py-1.5 text-sm';
const primary =
  'rounded-full bg-accent px-3 py-1.5 text-sm font-medium text-accent-fg disabled:opacity-50';

export function CreateWorkspaceDialog() {
  const { t } = useTranslation();
  const open = useWorkspaceUi((s) => s.createOpen);
  const close = useWorkspaceUi((s) => s.close);
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const reset = () => {
    setName('');
    setError(null);
    setBusy(false);
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        if (!o) {
          close();
          reset();
        }
      }}
      title={t('workspaces.createTitle')}
    >
      <form
        className="flex flex-col gap-3"
        onSubmit={(e) => {
          e.preventDefault();
          setBusy(true);
          setError(null);
          void supabase()
            .functions.invoke<{ ok?: boolean; error?: string }>('workspace-members', {
              body: { action: 'create', name: name.trim() },
            })
            .then(({ error: err }) => {
              if (err) {
                setError(t('workspaces.createFailed'));
                return;
              }
              close();
              reset();
              refreshWorkspacesSoon();
            })
            .finally(() => setBusy(false));
        }}
      >
        <label className="flex flex-col gap-1 text-sm">
          <span className="font-medium">{t('workspaces.nameLabel')}</span>
          <input
            autoFocus
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={t('workspaces.namePlaceholder')}
            className={field}
          />
        </label>
        {error && (
          <p role="alert" className="text-xs text-danger">
            {error}
          </p>
        )}
        <div className="flex justify-end">
          <button type="submit" disabled={busy || !name.trim()} className={cn(primary)}>
            {t('workspaces.createButton')}
          </button>
        </div>
      </form>
    </Dialog>
  );
}
